// extracted by mini-css-extract-plugin
module.exports = {"fallbackChevron":"FallbackChevron_fallbackChevron__pDXTq","front":"FallbackChevron_front__zcMsj","back":"FallbackChevron_back__YU161"};